module.exports = __webpack_public_path__ + "f9de70ca7514ce067cd492bfcd106930.jpg";